import {
  algoliaSearch,
  AlgoliaSearchParams,
} from "../../../../api/postCall/algoliaSearch";
import { getBearerToken } from "../../../../api/postCall/bearerToken";
import { AlgoliaSearchResponse } from "../../../../data-model/algoliaSearchModel";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { MyMedicalPaOrdersState } from "../hooks/useMyPaOrdersTableData";
import { generateMyMedicalPaOrdersTableDataFromAlgoliaRecords } from "../utils/generateTableDataFromAlgoliaRecords";

export const makePostCallForInitialDataFetch = async (
  payloads: AlgoliaSearchParams[],
  authStatusOptions: AuthStatusOptionModel[],
  setMyMedicalPaOrdersState: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersState>
  >,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
  setInitialDataFetchingExecuted: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  setMyMedicalPaOrdersState((prev) => ({ ...prev, loading: true }));

  try {
    await getBearerToken();

    const data: AlgoliaSearchResponse[] = [];

    for (const payload of payloads) {
      const response = await algoliaSearch(payload);
      const parsedResponse = JSON.parse(response) as AlgoliaSearchResponse;
      data.push(parsedResponse);
    }

    const combinedData = appendAllResponses(data);

    setMyMedicalPaOrdersState((prev) => ({
      ...prev,
      data: combinedData,
    }));
    setTableData(
      generateMyMedicalPaOrdersTableDataFromAlgoliaRecords(
        combinedData.hits ?? [],
        authStatusOptions,
      ),
    );
  } catch (error) {
    setMyMedicalPaOrdersState((prev) => ({ ...prev, error: error as string }));
  } finally {
    setMyMedicalPaOrdersState((prev) => ({ ...prev, loading: false }));
    setInitialDataFetchingExecuted(true);
  }
};

const appendAllResponses = (responses: AlgoliaSearchResponse[]) => {
  return responses.reduce((acc, response) => {
    return {
      ...response,
      hits: [...(acc.hits ?? []), ...(response.hits ?? [])],
    };
  }, {} as AlgoliaSearchResponse);
};
